import apiService from './api/api.service';

const mentorService = {
  // Get all mentors (accessible by students)
  getAllMentors: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = `/profile/mentors/list${queryString ? `?${queryString}` : ''}`;
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get mentor by ID
  getMentorById: async (mentorId) => {
    try {
      const response = await apiService.get(`/users/${mentorId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Ask a question to mentor
  askQuestion: async (data) => {
    try {
      const response = await apiService.post('/mentor-questions/ask', data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get student's questions
  getMyQuestions: async (params = {}) => {
    try {
      const response = await apiService.get('/mentor-questions/my-questions', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getQuestionHistory: async (params = {}) => {
    try {
      const response = await apiService.get('/mentor-questions/history', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get mentor reviews/ratings
  getMentorReviews: async (mentorId, params = {}) => {
    try {
      const response = await apiService.get(`/mentors/${mentorId}/reviews`, { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Submit mentor review
  submitReview: async (mentorId, data) => {
    try {
      const response = await apiService.post(`/mentors/${mentorId}/reviews`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get conversation with mentor
  getConversation: async (mentorId) => {
    try {
      const response = await apiService.get(`/mentor-questions/conversation/${mentorId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Send message to mentor
  sendMessage: async (data) => {
    try {
      const response = await apiService.post('/mentor-questions/messages', data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Mentor: Get pending questions
  getPendingQuestions: async () => {
    try {
      const response = await apiService.get('/mentor-questions/pending');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Mentor: Get question by ID
  getQuestionById: async (questionId) => {
    try {
      const response = await apiService.get(`/mentor-questions/${questionId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Mentor: Answer question
  answerQuestion: async (questionId, data) => {
    try {
      const response = await apiService.post(`/mentor-questions/${questionId}/answer`, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Mentor: Get earnings
  getMentorEarnings: async () => {
    try {
      const response = await apiService.get('/mentor-questions/earnings');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Mentor: Get all questions (answered and pending)
  getAllMentorQuestions: async () => {
    try {
      const response = await apiService.get('/mentor-questions/all');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Student: Get question by ID (to view answer and rate)
  getStudentQuestionById: async (questionId) => {
    try {
      const response = await apiService.get(`/mentor-questions/student/${questionId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Student: Rate an answer
  rateAnswer: async (questionId, rating) => {
    try {
      const response = await apiService.post(`/mentor-questions/${questionId}/rate`, { rating });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get user's credit balance
  getUserCredits: async () => {
    try {
      const response = await apiService.get('/mentor-questions/credits');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Preview credits required for a question
  previewQuestionCredits: async (data) => {
    try {
      const response = await apiService.post('/mentor-questions/preview-credits', data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Admin: Add credits to user
  addCreditsToUser: async (data) => {
    try {
      const response = await apiService.post('/mentor-questions/admin/add-credits', data);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default mentorService;
